import React, { FC, useEffect, useState, useRef } from "react";
import { Image, Form, Input, Button, Toast } from "antd-mobile";
import { registerService, authCaptcha, getServer } from "../../services/user";
import { useRequest } from "ahooks";
import { Encrypt } from "../../utils/GzipSts";
import { useNavigate } from "react-router-dom";
import { EyeInvisibleOutline, EyeOutline } from "antd-mobile-icons";
import styles from "./register.module.scss";
import Container from '../../components/Container';
import { CONTAINER_STYLES } from '../../styles/constants';
import { useLocation } from 'react-router-dom';
import axios from "axios";

import logo from '../../assets/images/logo.svg';
import userIcon from '../../assets/images/username_icon.svg';
import lookpassicon from '../../assets/images/lookpassicon.svg';
import captcha_icon from '../../assets/images/captcha_icon.svg';

const Register: FC = () => {
  const [Formregister] = Form.useForm();
  const navigator = useNavigate();
  const params = new URLSearchParams(window.location.search);
  const clubVlue = params.get('club');
  const agent = params.get('agent');
  const [captchaData, setCaptchaData] = useState<any>({}); //图形验证码相关信息
  const [passWordvisible, setPassWordvisible] = useState(false);
  const [RepassWordvisible, setRePassWordvisible] = useState(false);

  // const hasAgent = new URLSearchParams(window.location.search).has("agent");
  const hasAgent = agent;
  const hasFetched = useRef(false);

  useEffect(() => {
    if (!hasFetched.current) {
      hasFetched.current = true; // 标记已执行
      getAllApiUrl();
    }
  }, []);

  // 先校验
  const testhandleLogin = () => {
    let formData = Formregister.getFieldsValue();
    const { username, rePassword, password, captcha } = formData;
    if (!username) return Toast.show("请输入用户名");
    if (!password) return Toast.show("请输入密码");
    if (!rePassword) return Toast.show("请输入确认密码");
    if (!captcha) return Toast.show("请输入验证码");
    handleLogin();
  };

  const getAllApiUrl = async () => {
    try {
      const response = await axios.get(`/downloadConfig.json?${randomTwoDigit}`);
      const dataUrl: string[] = response.data[node_env]; // 确保 dataUrl 是字符串数组

      for (const url of dataUrl) {
        const success = await getApiurl(url + `?${randomTwoDigit}`);
        if (success) {
          console.log("请求成功，停止后续请求");
          break; // 只要有一个请求成功，就停止
        }
      }
    } catch (err) {
      console.error("下载配置失败:", err);
    }
  };

  const getApiurl = async (url: string): Promise<boolean> => {
    try {
      const response = await axios.get(url);
      const { h5_package, ios_package, android_package, api } = response.data;

      if (!h5_package || !ios_package || !android_package || !api) {
        console.warn("数据不完整，跳过:", url);
        return false;
      }

      const h5_num = getRandomNumber(h5_package);
      const ios_num = getRandomNumber(ios_package);
      const android_num = getRandomNumber(android_package);

      localStorage.setItem("apiUrl", api);

      getCaptchaData();

      downloadUrls.current.ios_url = `${ios_package[ios_num]}`;
      downloadUrls.current.android_url = `${android_package[android_num]}`;
      downloadUrls.current.h5_url = `${h5_package[h5_num]}`;

      console.log("成功请求:", url);
      return true; // 请求成功，返回 true，停止后续请求
    } catch (error) {
      console.error("请求失败:", url, error);
      return false; // 失败，继续请求下一个
    }
  };

  // 点击注册方法
  const { run: handleLogin } = useRequest(
    async () => {
      const formData = Formregister.getFieldsValue();
      const postData = {
        ...formData,
        password: Encrypt(formData.password),
        rePassword: Encrypt(formData.rePassword),
        agree: 1,
        captchaId: captchaData.captchaId,
        inviteCode: agent ? agent: "",
        club: clubVlue ? String(clubVlue) : ""
      };

      const apiUrl = localStorage.getItem('apiUrl');
      const apiUrls: any = apiUrl && apiUrl?.split(',');

      const tryRequest: any = async (index = 0) => {
        if (index >= apiUrls.length) throw new Error("所有 API 请求都失败");

        const url = apiUrls[index];
        try {
          let data = await registerService(postData, url);
          if (data && data.code === 0) {
            // 携带 formData 一起返回
            return { ...data, formData };
          }
        } catch (error) {
          console.warn(`请求失败: ${url}`, error);
        }

        return tryRequest(index + 1);
      };

      return tryRequest();
    },
    {
      manual: true,
      onSuccess(res: any) {
        const { code, formData } = res;
        if (code === 0) {
          navigator("/RegisteredSuccess", {
            state: {
              name: formData.username,
              password: formData.password,
            },
          });
        } else {
          getCaptchaData();
        }
      },
    }
  );

  interface DownloadConfig {
    ios_url: string;
    android_url: string;
    h5_url: string;
    download_url: string;
  }

  const downloadUrls = useRef<DownloadConfig>({
    ios_url: '',
    android_url: '',
    h5_url: '',
    download_url: '',
  });
  const node_env = process.env.NODE_ENV || "development";
  const randomTwoDigit = Math.floor(Math.random() * 90) + 10;

  // 获取验证码
  const { loading, run: getCaptchaData } = useRequest(
    async () => {
      const apiUrl = localStorage.getItem('apiUrl');
      const apiUrls: any = apiUrl && apiUrl?.split(',');
      // 递归请求，直到成功
      const tryRequest: any = async (index = 0) => {
        if (index >= apiUrls.length) {
          throw new Error("所有 API 请求都失败");
        }

        const url = apiUrls[index];
        try {
          let data = await authCaptcha(url);
          if (data && data.code === 0) {
            return data;
          }
        } catch (error) {
          console.warn(`请求失败: ${url}`, error);
        }

        // 递归尝试下一个 URL
        return tryRequest(index + 1);
      };

      return tryRequest();
    },
    {
      manual: true,
      onSuccess(res) {
        const { code, data } = res;
        if (code === 0) {
          setCaptchaData(data);
        }
      },
      onError(err) {
        console.error("所有 API 请求失败:", err);
      }
    }
  );

  // 获取随机数
  const getRandomNumber = (arr: []) => {
    const max = arr.length;
    return Math.floor(Math.random() * max);
  }

  // 点击登录
  const gotoLogin = () => {
    console.log("LOGIN跳转地址+++", downloadUrls.current.h5_url);
    window.location.href = downloadUrls.current.h5_url || "";
  }

  useRequest(
    async () => {
      const apiUrl = localStorage.getItem('apiUrl');
      const apiUrls: any = apiUrl && apiUrl?.split(',');

      // 递归请求，直到成功
      const tryRequest: any = async (index = 0) => {
        if (index >= apiUrls.length) {
          throw new Error("所有 API 请求都失败");
        }

        const url = apiUrls[index];
        try {
          let data = await getServer(url);
          if (data && data.code === 0) {
            return data;
          }
        } catch (error) {
          console.warn(`请求失败: ${url}`, error);
        }

        // 递归尝试下一个 URL
        return tryRequest(index + 1);
      };

      return tryRequest();
    },
    {
      manual: true,
      onSuccess(res) {
        const { code, data } = res;
        if (code === 0) {
          window.location.href = data.url || "";
        }
      },
      onError(err) {
        console.error("所有 API 请求失败:", err);
      }
    }
  );

  return (
    <Container style={{
      backgroundImage: `url(${require("../../assets/images/login_bg.png")})`,
    }}>
      <Image src={logo} className="max-w-[200px] mt-[94px]" />
      <div className={CONTAINER_STYLES.formWrapper}>
        <Form
          name="login_form"
          form={Formregister}
          onFinish={testhandleLogin}
          initialValues={{ remember: true }}
          footer={
            <Button block type="submit" className={CONTAINER_STYLES.button} size="large">注册</Button>
          }
        >
          {/* 账号 */}
          <Form.Item name="username" className={`${CONTAINER_STYLES.textCenter} ${styles.formItem}`}>
            <div className={CONTAINER_STYLES.inputContainer}>
              <Image src={userIcon} width={20} className={CONTAINER_STYLES.iconMargin} />
              <Input className="rounded-lg" placeholder="请输入6-20位（数字、大小写英文）" />
            </div>
          </Form.Item>
          {/* 密码 */}
          <Form.Item name="password" className={`${CONTAINER_STYLES.textCenter} ${styles.formItem}`}>
            <div className={CONTAINER_STYLES.inputContainer}>
              <Image src={lookpassicon} width={20} className={CONTAINER_STYLES.iconMargin} />
              <Input className="rounded-lg" placeholder="请输入6-20位（数字、大小写英文）" type={passWordvisible ? "text" : "password"} />
              <div className={styles.eye}>
                {!passWordvisible ? (
                  <EyeInvisibleOutline color="#fff" onClick={() => setPassWordvisible(true)} />
                ) : (
                  <EyeOutline color="#fff" onClick={() => setPassWordvisible(false)} />
                )}
              </div>
            </div>
          </Form.Item>
          {/*确认密码*/}
          <Form.Item name="rePassword" className={`${CONTAINER_STYLES.textCenter} ${styles.formItem}`}>
            <div className={CONTAINER_STYLES.inputContainer}>
              <Image src={lookpassicon} width={20} className={CONTAINER_STYLES.iconMargin} />
              <Input className="rounded-lg" placeholder="请再次输入密码" type={RepassWordvisible ? "text" : "password"} />
              <div className={styles.eye}>
                {!RepassWordvisible ? (
                  <EyeInvisibleOutline color="#fff" onClick={() => setRePassWordvisible(true)} />
                ) : (
                  <EyeOutline color="#fff" onClick={() => setRePassWordvisible(false)} />
                )}
              </div>
            </div>
          </Form.Item>
          {/* 验证码*/}
          <Form.Item name="captcha" className={`${CONTAINER_STYLES.textCenter} ${styles.formItem}`}>
            <div className={CONTAINER_STYLES.inputContainer}>
              <Image src={captcha_icon} width={20} className={CONTAINER_STYLES.iconMargin} />
              <Input className="rounded-lg w-40" placeholder="请输入验证码" />
              {captchaData?.picPath ? (
                <Image src={captchaData.picPath} height={20} className="min-w-6 min-h-6 w-24" onClick={getCaptchaData} />
              ) : (
                <span style={{
                  color: '#FFC962',
                  fontSize: '10px',
                }} onClick={getCaptchaData}>点击查看验证码</span>
              )}
            </div>
          </Form.Item>
        </Form>
        <div>
          {!hasAgent && (
            <div className="flex justify-center text-white items-center mt-4">
              返回<span className="text-[#FFC962] cursor-pointer" onClick={gotoLogin}>登录</span>
            </div>
          )}
        </div>
      </div>
    </Container>
  );
};

export default Register;
